module.exports = __webpack_public_path__ + "static/media/YB5F02_4.df62ec13.jpg";